import { ServiceLocator } from '@app/engine/core/service-locator';
export class CustomMeshFactory {
    meshes = [];
    remove(id) {
        this.meshes.splice(id, 1);
    }
    clear() {
        this.meshes = [];
    }
    add(mesh) {
        const renderer = ServiceLocator.getRenderer();
        mesh.init(renderer.gl);
        mesh.id = this.meshes.length;
        this.meshes.push(mesh);
    }
    generateMesh(...args) {
        if (this.checkCacheForMesh_(...args)) {
            // Mesh already exists
            return;
        }
        this.create_(...args);
    }
}
